/** ΔE00 for display: two decimals, em dash when there is no value. */
export const formatDeltaE = (value) => (value == null ? "—" : Number(value).toFixed(2));
